import { Services, joinURLPath } from '@sigma-frontend-libs/commons'

import { globalErrorHandler, request } from '@/utils'

export const processors = {
  data() {
    return {
      processors: [],
      processorsLoading: false
    }
  },

  mounted() {
    this.getProcessors()
  },

  methods: {
    async getProcessors() {
      try {
        this.processorsLoading = true
        const data = await request.find(joinURLPath(Services.providers, 'processors'))
        if (Array.isArray(data) && data.length) {
          this.processors = data
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.processorsLoading = false
      }
    }
  }
}

export const properties = (options = {}) => {
  const pathToAPI = joinURLPath(options.serviceName, 'properties')

  return {
    data() {
      return {
        properties: [],
        propertiesLoading: false
      }
    },

    mounted() {
      this.getProperties()
    },

    methods: {
      async getProperties() {
        try {
          this.propertiesLoading = true
          const data = await request.find(pathToAPI)
          if (Array.isArray(data) && data.length) {
            this.properties = data
          }
        } catch (error) {
          globalErrorHandler(error)
        } finally {
          this.propertiesLoading = false
        }
      }
    }
  }
}

export default {
  processors,
  properties
}
